import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HomePage } from './home/home';
import { LotteryModule } from '../lottery/lottery.module';
import { LotteryDetailPageModule } from '../lottery/lottery-detail/lottery-detail.module';
import { ProfileModule } from '../profile/profile.module';
import { SharedModule } from '../shared/shared.module';
import { ResultModule } from '../result/result.module';
import { SportsModule } from '../sports/sports.module';
import { VirtualSportsModule } from '../virtual-sports/virtual-sports.module';
import { ThirdPartyGamesModule } from '../thirdpartygames/thirdpartygames.module';
import { BaselineSharedModule } from 'baseline-lib';
import { SportsDetailPageModule } from '../sports/sports-detail/sports-detail.module';


@NgModule({
  declarations: [
     HomePage
  ],
  imports: [
    LotteryModule,
    LotteryDetailPageModule,
    ThirdPartyGamesModule,
    ProfileModule,
    SharedModule,
    BaselineSharedModule,
    ResultModule,
    SportsModule,
    SportsDetailPageModule,
    VirtualSportsModule,
    IonicPageModule.forChild(HomeModule),
  ],
  entryComponents: [
    HomePage
  ],
  exports: [
    HomePage
  ]
})
export class HomeModule {}



// WEBPACK FOOTER //
// ./src/app/home/home.module.ts